<template>
  <t-card class="tw:relative">
    <div
      class="tw:max-sm:pt-4 tw:max-sm:pl-4 tw:flex tw:flex-col tw:sm:flex-row tw:items-start tw:sm:h-[150px]"
    >
      <div
        class="tw:mr-5 tw:flex tw:items-center tw:justify-center tw:bg-transparent tw:border-2 tw:dark:border-zinc-500 tw:border-zinc-300 tw:rounded-lg tw:w-[150px] tw:min-w-[150px] tw:h-[150px]"
      >
        <slot name="map" />
      </div>
      <div
        class="tw:pt-4 tw:grow tw:w-full tw:h-full tw:md:w-min tw:flex tw:flex-col tw:justify-between"
      >
        <div class="tw:flex tw:flex-row tw:justify-between tw:mr-4">
          <div class="tw:overflow-x-auto tw:flex tw:flex-wrap tw:gap-2">
            <slot name="content" />
          </div>
        </div>
        <div
          class="tw:text-xl tw:sm:overflow-hidden tw:sm:line-clamp-1 tw:mr-4"
        >
          <slot name="title" />
        </div>
        <div class="tw:flex tw:flex-row tw:justify-end">
          <slot name="action" />
        </div>
      </div>
    </div>
  </t-card>
</template>
